/**
 * product.js — Jolat Proff produktsida (Agent B). Vanilla ES2019, defer.
 *
 * Ansvar:
 *   - Variantval (Färg-swatchar + Storlek/Antal-pills) → hittar variant.
 *   - Prisuppdatering ENBART via Jolat.updatePriceEl (spec §7 bugg 2) — aldrig
 *     textContent. Pro-rabatten räknas om i jolat.js från data-pro-pct.
 *   - à-pris (kartong → pris/st) + kartongbesparing (% mot styckpris).
 *   - Lager/art.nr/vikt/swatch-state/URL ?variant= vid byte.
 *   - Galleri (thumbs + tangentbord), flikar (ARIA), dokument-jump.
 *   - Sticky mobilköpbar (IntersectionObserver på köpkolumnen).
 *   - Fraktestimat per variant (JolatShipping, variantvikt × antal).
 *   - Åtgångskalkylator via window.JolatKalk (kalkylator-core.js) med fallback.
 *
 * Beroenden (laddas separat, alla med graceful fallback):
 *   window.Jolat        (assets/jolat.js)      — cart, updatePriceEl, money, displayOre
 *   window.JolatKalk    (kalkylator-core.js)   — åtgångsformler
 *   window.JolatShipping(shipping-estimate.liquid) — fraktestimat-text
 *   window.JolatCustomer{ pct }                — Pro-procent
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ----- Fallback-formler om kalkylator-core.js inte hunnit ladda ----- */
  function kalk() {
    if (window.JolatKalk) return window.JolatKalk;
    return {
      mlNeeded: function (b, d, l, spill) {
        b = +b; d = +d; l = +l; spill = Math.max(0, +spill || 0);
        if (!(b > 0) || !(d > 0) || !(l > 0)) return 0;
        return b * d * l * (1 + spill / 100);
      },
      suggestDepth: function (b) {
        b = +b; if (!(b > 0)) return 0;
        var d = b < 10 ? b : b / 2;
        return Math.min(15, Math.max(6, Math.round(d)));
      },
      cartridges: function (total, vol) {
        total = +total; vol = +vol;
        if (!(total > 0) || !(vol > 0)) return 0;
        return Math.ceil(total / vol);
      },
      backerRod: function (b) {
        b = +b; if (!(b > 0)) return { diameter: 0, standard: 0 };
        var raw = Math.round(b * 1.25 * 100) / 100;
        var rods = [6, 10, 13, 15, 20, 25, 30, 40, 50];
        var best = rods[0], diff = Infinity;
        rods.forEach(function (r) {
          var d = Math.abs(r - raw);
          if (d < diff || (d === diff && r > best)) { diff = d; best = r; }
        });
        return { diameter: raw, standard: best };
      },
      backerRodLength: function (l) { l = +l; return l > 0 ? l * 1.05 : 0; },
      parseVolumeMl: function (text, dens) {
        if (!text) return null;
        var m = String(text).match(/(\d+(?:[.,]\d+)?)\s*(ml|l|kg|g)\b/i);
        if (!m) return null;
        var val = parseFloat(m[1].replace(',', '.'));
        if (isNaN(val) || val <= 0) return null;
        var unit = m[2].toLowerCase();
        dens = +dens; if (!(dens > 0)) dens = 1.3;
        if (unit === 'ml') return val;
        if (unit === 'l') return val * 1000;
        if (unit === 'kg') return (val * 1000) / dens;
        if (unit === 'g') return val / dens;
        return null;
      }
    };
  }

  function money(ore) {
    if (window.Jolat && window.Jolat.money) return window.Jolat.money(window.Jolat.displayOre(ore));
    return new Intl.NumberFormat('sv-SE', { maximumFractionDigits: 0 }).format(Math.round((ore || 0) / 100)) + ' kr';
  }
  function formatWeight(grams) {
    if (window.Jolat && window.Jolat.formatWeight) return window.Jolat.formatWeight(grams);
    return new Intl.NumberFormat('sv-SE', { maximumFractionDigits: 1 }).format((grams || 0) / 1000) + ' kg';
  }
  function proPct() {
    return (window.JolatCustomer && window.JolatCustomer.pct) || 0;
  }

  /* Förpackningsantal ur "Kartong 12 st" — \b efter st så "2 stora" ej tas */
  function packSizeOf(variant) {
    if (!variant) return 1;
    var hay = (variant.title || '') + ' ' + ((variant.options || []).join(' '));
    var m = hay.match(/(\d+)\s*st\b/i);
    return m ? parseInt(m[1], 10) : 1;
  }
  function isKartong(variant) {
    if (!variant) return false;
    var hay = ((variant.title || '') + ' ' + ((variant.options || []).join(' '))).toLowerCase();
    return hay.indexOf('kartong') !== -1;
  }
  function volumeMlOf(variant, densitet) {
    if (!variant) return 0;
    if (variant.volym_ml && variant.volym_ml > 0) return variant.volym_ml;
    var ml = kalk().parseVolumeMl(variant.title || (variant.options || []).join(' '), densitet);
    return ml || 0;
  }

  /* ----- Filstorlek på dokumentkort (best effort, spec §6-B flik 4) ----- */
  /* product-docs.liquid renderar <span data-doc-size data-doc-url="..."></span>.
     Vi hämtar Content-Length via en HEAD-request och skriver " · X,X MB".
     Misslyckas anropet (t.ex. CORS mot Shopify CDN) lämnas elementet tomt
     utan att kasta fel — kortet visar då bara "PDF". */
  ready(function () {
    var sizeEls = $$('[data-doc-size][data-doc-url]');
    if (!sizeEls.length || typeof fetch !== 'function') return;
    sizeEls.forEach(function (el) {
      var url = el.getAttribute('data-doc-url');
      if (!url) return;
      fetch(url, { method: 'HEAD' }).then(function (r) {
        if (!r || !r.ok) return;
        var len = parseInt(r.headers.get('Content-Length'), 10);
        if (!len || isNaN(len) || len <= 0) return;
        var mb = len / 1024 / 1024;
        var label = mb >= 1
          ? new Intl.NumberFormat('sv-SE', { maximumFractionDigits: 1 }).format(Math.round(mb * 10) / 10) + ' MB'
          : new Intl.NumberFormat('sv-SE', { maximumFractionDigits: 0 }).format(Math.round(len / 1024)) + ' kB';
        el.textContent = ' · ' + label;
      }).catch(function () { /* tyst — kortet visar bara "PDF" */ });
    });
  });

  ready(function () {
    var pdp = $('[data-pdp]');
    if (!pdp) return;

    var dataEl = $('[data-jl-product]', pdp);
    var PRODUCT = null;
    if (dataEl) {
      try { PRODUCT = JSON.parse(dataEl.textContent); } catch (e) { PRODUCT = null; }
    }

    var densitet = parseFloat(pdp.getAttribute('data-densitet')) || 1.3;

    /* ---------------- State ---------------- */
    var state = {
      options: PRODUCT ? (PRODUCT.options || []).map(function () { return null; }) : [],
      qty: 1,
      variant: null
    };

    /* ---------------- Galleri ---------------- */
    (function initGallery() {
      var stage = $('[data-gallery-stage]', pdp);
      if (!stage) return;
      var slides = $$('[data-gallery-slide]', stage);
      var thumbs = $$('[data-gallery-thumb]', pdp);
      if (slides.length < 2) return;
      var active = 0;

      function show(i) {
        active = (i + slides.length) % slides.length;
        slides.forEach(function (s, idx) {
          var on = idx === active;
          s.classList.toggle('is-active', on);
          s.hidden = !on;
        });
        thumbs.forEach(function (t, idx) {
          var on = idx === active;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }

      thumbs.forEach(function (t, idx) {
        t.addEventListener('click', function () { show(idx); });
      });

      // Visa rätt bild när varianten har en kopplad media
      pdp.addEventListener('jl:variant:media', function (e) {
        var id = e.detail && e.detail.mediaId;
        if (!id) return;
        for (var i = 0; i < slides.length; i++) {
          if (String(slides[i].getAttribute('data-media-id')) === String(id)) { show(i); break; }
        }
      });

      // Svep på mobil
      var startX = 0;
      stage.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 50) show(active + (dx < 0 ? 1 : -1));
      }, { passive: true });
    })();

    /* ---------------- Flikar ---------------- */
    (function initTabs() {
      var wrap = $('[data-tabs]', pdp);
      if (!wrap) return;
      var tabs = $$('[role="tab"]', wrap);
      var panels = $$('[role="tabpanel"]', wrap);

      function activate(idx, focus) {
        tabs.forEach(function (t, i) {
          var on = i === idx;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          if (on && focus) t.focus();
        });
        panels.forEach(function (p, i) {
          var on = i === idx;
          p.classList.toggle('is-active', on);
          p.hidden = !on;
        });
      }

      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { activate(i); });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();
            var dir = e.key === 'ArrowRight' ? 1 : -1;
            activate((i + dir + tabs.length) % tabs.length, true);
          } else if (e.key === 'Home') {
            e.preventDefault(); activate(0, true);
          } else if (e.key === 'End') {
            e.preventDefault(); activate(tabs.length - 1, true);
          }
        });
      });

      // Dokument-snabblänkar i köpkolumnen → aktivera Dokument-fliken
      $$('[data-doc-jump]', pdp).forEach(function (link) {
        link.addEventListener('click', function (e) {
          var target = link.getAttribute('href');
          var panel = target ? $(target, wrap) : null;
          if (!panel) return;
          var idx = panels.indexOf(panel);
          if (idx > -1) {
            e.preventDefault();
            activate(idx);
            panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });
    })();

    /* ---------------- Variantlogik ---------------- */
    var idInput = $('[data-variant-id]', pdp);
    var priceWrap = $('[data-price-wrap]', pdp);
    var stickyPrice = $('[data-sticky-price]', pdp);
    var perunitWrap = $('[data-perunit]', pdp);
    var perunitText = $('[data-perunit-text]', pdp);
    var cartonsave = $('[data-cartonsave]', pdp);
    var stockEl = $('[data-stock]', pdp);
    var stockText = $('[data-stock-text]', pdp);
    var artnrEl = $('[data-jl-artnr]', pdp);
    var addBtn = $('[data-add-btn]', pdp);
    var addLabel = $('[data-add-label]', pdp);
    var stickyAdd = $('[data-sticky-add]', pdp);
    var stickyVariant = $('[data-sticky-variant]', pdp); // variantnamn i sticky-baren (PRIO1)
    var qtyInput = $('[data-qty-input]', pdp);
    var shipWrap = $('[data-ship-wrap]', pdp);
    // Ring och beställ: telefonknappar (köpkolumn + sticky) och antal-väljaren
    // växlas mot varukorgsknapparna beroende på om vald variant är köpbar.
    var callBtn = $('[data-call-btn]', pdp);
    var stickyCall = $('[data-sticky-call]', pdp);
    var mailBtn = $('[data-mail-btn]', pdp);
    var qtyWrap = $('[data-qty]', pdp);

    /* Slut i lager → göm varukorgsknapp + antal, visa telefon- och mejlknapp
       (och tvärtom). */
    function toggleBuyButtons(available) {
      var out = !available;
      if (addBtn) addBtn.hidden = out;
      if (qtyWrap) qtyWrap.hidden = out;
      if (callBtn) callBtn.hidden = !out;
      if (mailBtn) mailBtn.hidden = !out;
      if (stickyAdd) stickyAdd.hidden = out;
      if (stickyCall) stickyCall.hidden = !out;
    }

    /* Mejlknappens ämnesrad/brödtext följer vald variant. */
    function syncMailBtn(v) {
      if (!mailBtn || !v) return;
      var prod = mailBtn.getAttribute('data-mail-product') || '';
      var line = prod + (v.title && v.title !== 'Default Title' ? ' – ' + v.title : '');
      var body = 'Hej!\r\n\r\nJag vill beställa:\r\n' + line +
        (v.sku ? ' (art.nr ' + v.sku + ')' : '') +
        '\r\nAntal:\r\n\r\nNamn:\r\nTelefon:\r\nLeveransadress:';
      mailBtn.href = 'mailto:' + (mailBtn.getAttribute('data-mail-to') || 'info@jolat.se') +
        '?subject=' + encodeURIComponent('Beställning: ' + line) +
        '&body=' + encodeURIComponent(body);
    }

    function findVariant() {
      if (!PRODUCT || !PRODUCT.variants) return null;
      return PRODUCT.variants.filter(function (v) {
        return state.options.every(function (val, i) {
          return val == null || (v.options[i] || null) === val;
        });
      })[0] || null;
    }

    /* Shopify-standard: när vald optionskombination inte motsvarar någon variant
       (t.ex. "Påse 600 ml" + "Kartong 12 st" finns ej i FS702), snäpp övriga
       options till en GILTIG variant. Vi pinnar den NYSS ändrade optionen
       (changedPos, 1-baserad) och väljer den första KÖPBARA varianten som matchar
       den (spec/TESTDATA: föredra availableForSale). Fallback: första matchande
       variant, därefter vilken variant som helst. Returnerar null bara om
       produkten helt saknar varianter. */
    function snapToValidVariant(changedPos) {
      if (!PRODUCT || !PRODUCT.variants || !PRODUCT.variants.length) return null;
      var idx = changedPos ? changedPos - 1 : -1;
      var pinned = idx > -1 ? state.options[idx] : null;
      var candidates = PRODUCT.variants.filter(function (v) {
        return pinned == null || (v.options[idx] || null) === pinned;
      });
      if (!candidates.length) candidates = PRODUCT.variants.slice();
      var buyable = candidates.filter(function (v) { return v.available; });
      var chosen = buyable[0] || candidates[0] || null;
      if (chosen) {
        // Synka state + UI till den valda variantens samtliga optionsvärden
        state.options = (chosen.options || []).slice();
        syncOptionUI();
      }
      return chosen;
    }

    /* Markera rätt pill/swatch som aktiv enligt state.options + uppdatera
       legend-värdet ("Storlek: <värde>"). Anropas efter snap så användaren ser
       den faktiskt valda (giltiga) kombinationen, inte den döda. */
    function syncOptionUI() {
      $$('[data-option-position]', pdp).forEach(function (b) {
        var pos = parseInt(b.getAttribute('data-option-position'), 10);
        if (!pos) return;
        var on = b.getAttribute('data-option-value') === state.options[pos - 1];
        b.classList.toggle('is-active', on);
        if (b.getAttribute('role') === 'radio') b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      for (var pos = 1; pos <= state.options.length; pos++) {
        var cur = $('[data-current-option="' + pos + '"]', pdp);
        if (cur && state.options[pos - 1] != null) cur.textContent = state.options[pos - 1];
      }
    }

    /* Samma regel som delivery-badge.liquid (kortet): grön endast vid spårat
       saldo > 0. Köpbar utan eget saldo — även ospårad — = leveranslöfte. */
    function stockState(v) {
      if (!v || !v.available) return 'out';
      if (v.inventory_management && v.inventory_quantity > 0) return 'in_stock';
      return 'backorder';
    }

    /* Leveranslöfte: etiketterna renderas av Liquid som data-label-* på
       [data-stock] (metafältet custom.leveranstid styr backorder-texten).
       Fallbacks används bara om attributen saknas. */
    var STOCK_TEXT = {
      in_stock: (stockEl && stockEl.getAttribute('data-label-in')) || (window.JolatStrings && window.JolatStrings.inStock) || 'I lager',
      backorder: (stockEl && stockEl.getAttribute('data-label-backorder')) || 'Skickas inom 2–4 arbetsdagar',
      out: (stockEl && stockEl.getAttribute('data-label-out')) || 'Tillfälligt slut'
    };

    function effectivePrice(orePrice) {
      var pct = proPct();
      return pct > 0 ? Math.round(orePrice * (100 - pct) / 100) : orePrice;
    }

    function update() {
      var v = state.variant;

      if (!v) {
        // Normalt onåbart: selectOption() snäpper alltid till en giltig variant.
        // Inträffar bara om produkten helt saknar köpbara varianter. Lämna då
        // INTE stale pris/lager kvar (bugg i gamla temat: avstängd knapp utan
        // förklaring) — nollställ och förklara.
        if (addBtn) { addBtn.disabled = true; if (addLabel) addLabel.textContent = addBtn.getAttribute('data-label-sold') || 'Tillfälligt slut'; }
        if (stickyAdd) stickyAdd.disabled = true;
        toggleBuyButtons(false);
        if (stockEl) stockEl.setAttribute('data-state', 'out');
        if (stockText) stockText.textContent = 'Välj en giltig kombination';
        if (perunitWrap) perunitWrap.hidden = true;
        if (cartonsave) cartonsave.hidden = true;
        return;
      }

      // URL ?variant=
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* ignore */ }

      if (idInput) idInput.value = v.id;

      // Enhetsetikett & à-pris
      var unit = isKartong(v) ? '/kartong' : '/st';
      var compare = (v.compare_at_price && v.compare_at_price > v.price) ? v.compare_at_price : 0;

      // Pris (LIST-pris i öre inkl moms; Jolat räknar pro-rabatt själv från data-pro-pct)
      if (window.Jolat && window.Jolat.updatePriceEl && priceWrap) {
        window.Jolat.updatePriceEl(priceWrap, v.price, { compareOre: compare, unitLabel: unit });
      }
      if (window.Jolat && window.Jolat.updatePriceEl && stickyPrice) {
        window.Jolat.updatePriceEl(stickyPrice, v.price, { compareOre: compare });
      }

      // à-pris vid kartong: effektivt styckpris efter ev. pro-rabatt
      var pack = packSizeOf(v);
      if (perunitWrap && perunitText) {
        if (isKartong(v) && pack > 1) {
          var perOre = Math.round(effectivePrice(v.price) / pack);
          perunitText.textContent = 'à ' + money(perOre) + '/st (' + pack + ' st)';
          perunitWrap.hidden = false;
        } else {
          perunitWrap.hidden = true;
        }
      }

      // Kartongbesparing: jämför styckpris i kartong mot styckvariantens pris
      if (cartonsave) {
        var saved = cartonSavingPct(v, pack);
        if (saved > 0) {
          cartonsave.textContent = 'Köp kartong — spara ' + saved + ' % mot styckpris';
          cartonsave.hidden = false;
        } else {
          cartonsave.hidden = true;
        }
      }

      // Lager
      var st = stockState(v);
      if (stockEl) stockEl.setAttribute('data-state', st);
      if (stockText) stockText.textContent = STOCK_TEXT[st] || STOCK_TEXT.in_stock;

      // Art.nr
      if (artnrEl && v.sku) artnrEl.textContent = v.sku;

      // Köpknapp
      if (addBtn) {
        addBtn.disabled = !v.available;
        if (addLabel) addLabel.textContent = v.available
          ? (addBtn.getAttribute('data-label-add') || 'Lägg i varukorgen')
          : (addBtn.getAttribute('data-label-sold') || 'Tillfälligt slut');
      }
      if (stickyAdd) stickyAdd.disabled = !v.available;
      toggleBuyButtons(!!v.available); // slut → "Ring och beställ" i stället för varukorg
      syncMailBtn(v); // mejlknappens ämnesrad följer varianten
      if (stickyVariant) stickyVariant.textContent = v.title; // synka variantnamnet i sticky-baren

      // Galleri-media
      if (v.featured_media) {
        pdp.dispatchEvent(new CustomEvent('jl:variant:media', { detail: { mediaId: v.featured_media } }));
      }

      updateShipping();
      if (typeof recalc === 'function') recalc();
    }

    // Hitta billigaste styckvariant för samma färg/storlek (för besparing-jämförelse)
    function cartonSavingPct(v, pack) {
      if (!PRODUCT || !isKartong(v) || pack <= 1) return 0;
      // styckpris i denna kartong
      var perCarton = v.price / pack;
      // leta efter "st"-variant (1 st / styck) med samma övriga options
      var single = PRODUCT.variants.filter(function (o) {
        if (o.id === v.id) return false;
        if (isKartong(o)) return false;
        return packSizeOf(o) <= 1;
      })[0];
      if (!single) return 0;
      if (single.price <= 0 || perCarton >= single.price) return 0;
      return Math.round((1 - perCarton / single.price) * 100);
    }

    function updateShipping() {
      if (!shipWrap) return;
      var v = state.variant;
      var grams = ((v && v.weight) || 0) * state.qty;
      var el = $('[data-shipping-estimate]', shipWrap);
      if (el && window.JolatShipping && window.JolatShipping.render) {
        window.JolatShipping.render(el, grams);
        // ta bort follow-cart så cart-events inte skriver över variant-vikten
        el.removeAttribute('data-follow-cart');
      } else if (el) {
        var t = $('[data-shipping-text]', el) || el;
        t.textContent = 'Frakt beräknas i kassan';
      }
    }

    function selectOption(position, value) {
      state.options[position - 1] = value;
      state.variant = findVariant();

      // Ogiltig kombination (vanligt i verklig data, t.ex. Påse 600 ml saknar
      // Kartong 12 st): snäpp övriga options till en giltig variant och pinna
      // det användaren just valde. snapToValidVariant() synkar HELA optionsUI.
      if (!state.variant) {
        state.variant = snapToValidVariant(position);
      }

      // Markera vald option (snapToValidVariant har redan synkat UI vid snap;
      // detta täcker det vanliga giltiga fallet utan extra DOM-svep).
      $$('[data-option-position="' + position + '"]', pdp).forEach(function (b) {
        var on = b.getAttribute('data-option-value') === state.options[position - 1];
        b.classList.toggle('is-active', on);
        if (b.getAttribute('role') === 'radio') b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var cur = $('[data-current-option="' + position + '"]', pdp);
      if (cur && state.options[position - 1] != null) cur.textContent = state.options[position - 1];

      update();
    }

    if (PRODUCT) {
      // Initiera valda options från active-knappar
      $$('[data-option-position].is-active', pdp).forEach(function (b) {
        var pos = parseInt(b.getAttribute('data-option-position'), 10);
        if (pos) state.options[pos - 1] = b.getAttribute('data-option-value');
      });
      state.variant = findVariant();

      $$('[data-option-position]', pdp).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var pos = parseInt(btn.getAttribute('data-option-position'), 10);
          var val = btn.getAttribute('data-option-value');
          if (pos && val) selectOption(pos, val);
        });
        // Tangentbord: pilar inom radiogroup
        btn.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
          e.preventDefault();
          var group = btn.parentNode;
          var siblings = $$('[data-option-position]', group);
          var idx = siblings.indexOf(btn);
          var dir = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : -1;
          var next = siblings[(idx + dir + siblings.length) % siblings.length];
          if (next) {
            next.focus();
            var pos = parseInt(next.getAttribute('data-option-position'), 10);
            selectOption(pos, next.getAttribute('data-option-value'));
          }
        });
      });
    }

    /* ---------------- Kvantitet ---------------- */
    (function initQty() {
      var minus = $('[data-qty-minus]', pdp);
      var plus = $('[data-qty-plus]', pdp);
      function setQty(n) {
        state.qty = Math.max(1, n || 1);
        if (qtyInput) qtyInput.value = state.qty;
        updateShipping();
      }
      if (qtyInput) {
        state.qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
        qtyInput.addEventListener('input', function () { setQty(parseInt(qtyInput.value, 10) || 1); });
      }
      if (minus) minus.addEventListener('click', function () { setQty(state.qty - 1); });
      if (plus) plus.addEventListener('click', function () { setQty(state.qty + 1); });
    })();

    /* ---------------- Lägg i varukorgen ---------------- */
    var form = $('#jl-product-form', pdp);
    function addToCart() {
      var v = state.variant;
      if (!v || !v.available) return;
      var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      var origLabel = addLabel ? addLabel.textContent : '';
      if (addBtn) addBtn.setAttribute('data-state', 'busy');

      var promise;
      if (window.Jolat && window.Jolat.cart && window.Jolat.cart.add) {
        promise = Promise.resolve(window.Jolat.cart.add([{ id: v.id, quantity: qty }]));
      } else {
        promise = fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: qty }] })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return fetch('/cart.js', { headers: { Accept: 'application/json' } });
        }).then(function (r) { return r.json(); }).then(function (cart) {
          document.dispatchEvent(new CustomEvent('jolat:cart:updated', { detail: cart }));
          if (window.JolatDrawer && window.JolatDrawer.open) window.JolatDrawer.open();
          return cart;
        });
      }
      promise.then(function () {
        if (addBtn) addBtn.setAttribute('data-state', 'done');
        if (addLabel) addLabel.textContent = 'Tillagd';
        setTimeout(function () {
          if (addBtn) addBtn.setAttribute('data-state', 'idle');
          if (addLabel) addLabel.textContent = origLabel;
        }, 1800);
      }).catch(function () {
        if (addBtn) addBtn.setAttribute('data-state', 'idle');
      });
    }

    if (form) {
      form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(); });
    }
    if (stickyAdd) {
      stickyAdd.addEventListener('click', function (e) { e.preventDefault(); addToCart(); });
    }

    /* ---------------- Sticky mobilköpbar ---------------- */
    (function initSticky() {
      var bar = $('[data-sticky-bar]', pdp);
      var buybox = $('[data-buybox]', pdp);
      if (!bar || !buybox || !('IntersectionObserver' in window)) return;
      var obs = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting || e.intersectionRatio < 0.15;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      }, { threshold: [0, 0.15, 1] });
      obs.observe(buybox);
    })();

    /* ---------------- Åtgångskalkylator ---------------- */
    var recalc = null;
    (function initCalc() {
      var root = $('[data-calc]', pdp);
      if (!root) return;

      var inB = $('[data-calc-input="bredd"]', root);
      var inD = $('[data-calc-input="djup"]', root);
      var inL = $('[data-calc-input="langd"]', root);
      var inS = $('[data-calc-input="spill"]', root);
      var outTotal = $('[data-calc-total]', root);
      var outPacks = $('[data-calc-packs]', root);
      var outPacksLabel = $('[data-calc-packs-label]', root);
      var perpack = $('[data-calc-perpack]', root);
      var backer = $('[data-calc-backer]', root);
      var backerText = $('[data-calc-backer-text]', root);
      var cta = $('[data-calc-cta]', root);
      // Auto-djup-läget initieras från markup-kontraktet data-calc-depth-auto
      // (sätts på djupfältet i main-product.liquid). Default true om attributet saknas.
      var depthAutoActive = !inD || inD.getAttribute('data-calc-depth-auto') !== 'false';

      // Auto-förslag på djup tills användaren ändrar manuellt
      if (inD) {
        inD.addEventListener('input', function () { depthAutoActive = false; });
      }
      function syncDepthSuggestion() {
        if (!inD || !depthAutoActive) return;
        var b = parseFloat(inB && inB.value) || 0;
        var d = kalk().suggestDepth(b);
        if (d > 0) inD.value = d;
      }

      recalc = function () {
        syncDepthSuggestion();
        var b = parseFloat(inB && inB.value) || 0;
        var d = parseFloat(inD && inD.value) || 0;
        var l = parseFloat(inL && inL.value) || 0;
        var spill = parseFloat(inS && inS.value);
        if (isNaN(spill)) spill = 10;

        var totalMl = kalk().mlNeeded(b, d, l, spill);
        if (outTotal) outTotal.textContent = new Intl.NumberFormat('sv-SE', { maximumFractionDigits: 0 }).format(Math.round(totalMl));

        var v = state.variant;
        var volMl = volumeMlOf(v, densitet);
        var cartridgesNeeded = kalk().cartridges(totalMl, volMl);

        // Förpackningar för vald variant: kartong = ceil(patroner / pack)
        var pack = packSizeOf(v);
        var packs;
        if (isKartong(v) && pack > 1) {
          packs = cartridgesNeeded > 0 ? Math.ceil(cartridgesNeeded / pack) : 0;
          if (outPacksLabel) outPacksLabel.textContent = packs === 1 ? 'kartong' : 'kartonger';
        } else {
          packs = cartridgesNeeded;
          if (outPacksLabel) outPacksLabel.textContent = 'förpackningar';
        }
        if (outPacks) outPacks.textContent = packs;

        // à-volym-rad
        if (perpack) {
          if (volMl > 0 && totalMl > 0) {
            var perPackVol = isKartong(v) && pack > 1 ? (volMl * pack) : volMl;
            perpack.textContent = 'Vald förpackning rymmer ca ' +
              new Intl.NumberFormat('sv-SE', { maximumFractionDigits: 0 }).format(Math.round(perPackVol)) + ' ml' +
              (isKartong(v) && pack > 1 ? ' (' + pack + ' patroner)' : '');
            perpack.hidden = false;
          } else {
            perpack.hidden = true;
          }
        }

        // Bottningslist-tips
        if (backer && backerText) {
          if (b > 0 && l > 0) {
            var rod = kalk().backerRod(b);
            var rodLen = kalk().backerRodLength(l);
            backerText.textContent = 'Fogbredd ' + Math.round(b) + ' mm → bottningslist ' + rod.standard +
              ' mm, ca ' + new Intl.NumberFormat('sv-SE', { maximumFractionDigits: 1 }).format(Math.round(rodLen * 10) / 10) + ' m.';
            backer.hidden = false;
          } else {
            backer.hidden = true;
          }
        }

        // CTA — enhetsordet matchar vald förpackningstyp (patron/påse osv. = st,
        // kartong = kartong/kartonger) så texten inte blir motsägelsefull.
        if (cta) {
          cta.dataset.qty = packs;
          cta.disabled = packs < 1 || !v || !v.available;
          var enhet = (isKartong(v) && pack > 1) ? (packs === 1 ? 'kartong' : 'kartonger') : 'st';
          cta.textContent = packs < 1
            ? 'Fyll i mått ovan'
            : 'Lägg ' + packs + ' ' + enhet + ' i varukorgen';
        }
      };

      ['bredd', 'djup', 'langd', 'spill'].forEach(function (k) {
        var el = $('[data-calc-input="' + k + '"]', root);
        if (el) el.addEventListener('input', recalc);
      });

      if (cta) {
        cta.addEventListener('click', function () {
          var qty = parseInt(cta.dataset.qty, 10) || 0;
          var v = state.variant;
          if (qty < 1 || !v || !v.available) return;
          cta.disabled = true;
          var orig = cta.textContent;
          cta.textContent = 'Lägger i varukorgen …';
          var promise;
          if (window.Jolat && window.Jolat.cart && window.Jolat.cart.add) {
            promise = Promise.resolve(window.Jolat.cart.add([{ id: v.id, quantity: qty }]));
          } else {
            promise = fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: v.id, quantity: qty }] })
            }).then(function (r) { return r.json(); }).then(function () {
              if (window.JolatDrawer && window.JolatDrawer.open) window.JolatDrawer.open();
            });
          }
          promise.then(function () {
            cta.textContent = '✓ Tillagt';
            setTimeout(function () { cta.disabled = false; recalc(); }, 1500);
          }).catch(function () {
            cta.textContent = 'Något gick fel — försök igen';
            setTimeout(function () { cta.disabled = false; cta.textContent = orig; }, 2000);
          });
        });
      }

      recalc();
    })();

    // Första render
    update();

    // Re-rendera köprutan (pris, à-pris/st, kartongbesparing) när momsläget växlas —
    // à-priset var annars fryst i föregående moms-läge.
    document.addEventListener('jolat:tax:changed', update);
  });
})();
